var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.reviewList.length > 0)?_c('div',{staticClass:"ui-review-wrapper ui-detail-common",on:{"click":function($event){return _vm.getCommentStatus()}}},[_vm._m(0),_c('div',{staticClass:"goods-review-body"},[_c('review-list',{attrs:{"list":_vm.reviewList}})],1)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"review-header header"},[_c('h3',[_vm._v("تقييم")])])
}]

export { render, staticRenderFns }